/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Disclaimer } from '../../models/disclaimer';

export interface GetDisclaimer$Params {
  type: 'CVDDNRFLTR';
}

export function getDisclaimer(http: HttpClient, rootUrl: string, params: GetDisclaimer$Params, context?: HttpContext): Observable<StrictHttpResponse<Disclaimer>> {
  const rb = new RequestBuilder(rootUrl, getDisclaimer.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Disclaimer>;
    })
  );
}

getDisclaimer.PATH = '/disclaimers/{type}';
